import 'Styles/templates/page.facetspodcast.scss';

import AutoplayVideo from '../components/autoplay-video';

AutoplayVideo();